import { render, staticRenderFns } from "./rcommendaTableEdit.vue?vue&type=template&id=1c41341f"
import script from "./rcommendaTableEdit.vue?vue&type=script&lang=js"
export * from "./rcommendaTableEdit.vue?vue&type=script&lang=js"
import style0 from "./rcommendaTableEdit.vue?vue&type=style&index=0&id=1c41341f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports